import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card rounded-3 bg-white border-0 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { style: {"margin":"-26px -23px -25px -22px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex\"><div class=\"flex-grow-1 me-3\"><div class=\"d-flex align-items-start\"><div class=\"me-4\"><span class=\"d-block mb-2\">Revenue</span><h3 class=\"mb-0 fs-20\">$194,712</h3></div><span class=\"d-inline-block border-success border bg-success bg-opacity-10 text-success px-2 rounded-pill fs-12 fw-medium position-relative top-4\"> + 60% </span></div></div><div class=\"flex-shrink-0\"><span class=\"fs-12\">Last 7 days</span></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "bar",
              height: "125",
              options: _ctx.revenueChart,
              series: _ctx.revenue
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}